import { render } from "./Risk.m.vue?vue&type=template&id=0449a2c4"
import script from "./Risk.m.vue?vue&type=script&lang=js"
export * from "./Risk.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__